import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { useDispatch, useSelector } from 'react-redux';
import { removeFilter, updateFilters } from '../../../../utils';
import { RootState } from '../../../../../../redux/root';
import { FilterEntry } from '../../../../../../redux/slices/filterSlice';

type Props = {
  name: string;
};
const CellFilter: FC<Props> = ({ name }) => {
  const filters: FilterEntry[] = useSelector((state: RootState) => state.filters.filters);
  const dispatch = useDispatch();
  const [value, setValue] = useState<string>('');
  const onChange = e => {
    setValue(e.currentTarget.value);
    updateFilters(e.currentTarget.name, e.currentTarget.value, filters, dispatch); // name, value, filters, dispatch
  };

  const clearValue = _name => {
    const payload = {
      currentTarget: {
        name: _name,
        value: '',
      },
    };
    setValue('');
    const { name, value } = payload.currentTarget;
    updateFilters(name, value, filters, dispatch);
  };
  return (
    <Wrapper>
      <input name={name} onChange={onChange} value={value} autoComplete="off" placeholder="Search" />
      <SearchWrapper>
        {value.length > 0 && <ClearIcon onClick={e => clearValue(name)} />}
        {value.length === 0 && <SearchIcon />}
      </SearchWrapper>
    </Wrapper>
  );
};

export default CellFilter;

const Wrapper = styled.div`
  position: relative;
  margin: 0 10px 10px 10px;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 8px;
  height: 30px;
  min-width: 0;
  display: flex;
  align-items: center;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: var(--neutral-400);
  }

  &:focus-within {
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }

  input {
    flex: 1;
    min-width: 0;
    height: 100%;
    padding: 0 32px 0 12px;
    border: none;
    outline: none;
    background: transparent;
    font-family: inherit;
    font-size: 0.8125rem;
    color: var(--mainText);

    &::placeholder {
      color: var(--neutral-400);
    }
  }
`;

const SearchWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--neutral-400);
  cursor: pointer;
  transition: color 0.15s ease;

  svg {
    font-size: 1rem;
  }

  &:hover {
    color: var(--neutral-600);
  }
`;
